import { TAG_VARIANTS } from '@private/components';

/** Operators whose value is multi-valued in the UI and comma-joined on the wire. */
export const RECON_MULTI_OPERATIONS = ['IN', 'NOT_IN'];

export enum RECONCILIATION_KEYS {
  RECONCILIATION_FILE = 'reconciliationFile',
  RECONCILIATION_FOLDER = 'reconciliationFolder',
  RECONCILIATION_FOLDER_MAPPING = 'reconciliationFolderMapping',
  RECONCILIATION_FOLDER_MAPPING_VALUES = 'reconciliationFolderMappingValues',
  RECONCILIATION_FOLDERS = 'reconciliationFolders',
  RECONCILIATION_RESOLVE = 'reconciliationResolve',
  RECONCILIATION_RESULTS = 'reconciliationResults',
}

export enum RECONCILIATION_STATUS {
  DIFFERENT_VALUES = 'DIFFERENT_VALUES',
  ONLY_IN_CSV = 'ONLY_IN_CSV',
  ONLY_IN_PAYMENT = 'ONLY_IN_PAYMENT',
  RESOLVED = 'RESOLVED',
  SAME = 'SAME',
}

export const RECONCILIATION_STATUS_TAG_VARIANTS: Record<
  RECONCILIATION_STATUS,
  TAG_VARIANTS
> = {
  [RECONCILIATION_STATUS.DIFFERENT_VALUES]: TAG_VARIANTS.ERROR,
  [RECONCILIATION_STATUS.ONLY_IN_CSV]: TAG_VARIANTS.WARNING,
  [RECONCILIATION_STATUS.ONLY_IN_PAYMENT]: TAG_VARIANTS.WARNING,
  [RECONCILIATION_STATUS.RESOLVED]: TAG_VARIANTS.BLUE,
  [RECONCILIATION_STATUS.SAME]: TAG_VARIANTS.SUCCESS,
};
